/**
 * ★ Fase 59.P2 — estratto da LeadDetailPage.jsx (split componenti oversize).
 * Comportamento e data-testid INVARIATI.
 */
import React from 'react';
import { Flame, Snowflake, Zap, ThermometerSun } from 'lucide-react';

const TEMP_CONFIG = {
  cold: { label: 'COLD', icon: Snowflake, bg: 'bg-slate-500', text: 'text-white' },
  warm: { label: 'WARM', icon: ThermometerSun, bg: 'bg-amber-500', text: 'text-white' },
  hot: { label: 'HOT', icon: Flame, bg: 'bg-orange-600', text: 'text-white' },
  blazing: { label: 'BLAZING', icon: Zap, bg: 'bg-red-600', text: 'text-white animate-pulse' },
};

export function TempBadge({ temperature }) {
  const cfg = TEMP_CONFIG[temperature] || TEMP_CONFIG.cold;
  const Icon = cfg.icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-[10px] font-bold tracking-[0.2em] uppercase px-2.5 py-1 rounded-full ${cfg.bg} ${cfg.text}`}
      data-testid="lead-temperature-badge"
      title={`Lead temperature: ${cfg.label}`}
    >
      <Icon className="w-3 h-3" />
      {cfg.label}
    </span>
  );
}
